import styled from 'styled-components';
import { devices, fontFamily, fontSize } from '../../../Styles';

export const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[20]};
  .errorMsg {
    color: ${({ theme }) => theme.palette.alert100};
    margin-top: 8px;
    margin-bottom: 0px;
  }
`;

export const InputContentContainer = styled.div<{ isError?: boolean }>`
  box-sizing: border-box;
  display: flex;
  border-bottom: ${({ isError, theme }) =>
    isError ? `1px solid ${theme.palette.alert100}` : `1px solid ${theme.brandTheme.brand100}`};
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 100%;
  position: relative;
  i {
    margin-right: 8px;
  }
  @media ${devices['no-mobile']} {
    justify-content: flex-start;
    i {
      margin-right: 4px;
    }
  }
  .custom_select__control {
    border: none;
    min-height: auto;
    height: auto;
    font-size: ${fontSize['inputs-text-mobile']};
    font-family: ${fontFamily};
    @media ${devices['no-mobile']} {
      font-size: ${fontSize['inputs-text-desktop']};
    }
  }
  .custom_select__value-container {
    padding-left: 0;
  }
  .custom_select__menu {
    font-size: ${fontSize['inputs-text-mobile']};
    font-family: ${fontFamily};
    @media ${devices['no-mobile']} {
      font-size: ${fontSize['inputs-text-desktop']};
    }
  }
  .custom_select__indicator-separator {
    display: none;
  }
  .custom_select__placeholder {
    color: ${({ theme }) => theme.palette.graysPlaceholder}!important;
  }
`;
